import React, { PropsWithChildren } from 'react';
import { Modifier } from '../../../../lib/bemUtils/Modifier';
import bem from '../../../../lib/bemUtils/bem';

export enum PageLeadModifier {
  INLINE_ICON = 'inline-icon',
  INVISIBLE = 'invisible',
}

type PageLead = PropsWithChildren<{
  modifier?: Modifier<PageLeadModifier>;
}>;

export function PageLead({ children, modifier }: PageLead) {
  return (
    // sometimes we render an invisible header (for design reasons mostly)
    <header className={bem('page-lead', modifier)}>{children}</header>
  );
}
